var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "x0pfwhiqra",
    d: "M5.911 3.091L5.911 7.341 7.411 7.341 7.411 1.591 1.661 1.591 1.661 3.091z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1108 -352) translate(358 182) translate(105 135) matrix(1 0 0 -1 645 60) translate(8 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1jwkup5qyb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x0pfwhiqra"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#ccc",
    fillRule: "nonzero",
    transform: "rotate(315 4.536 4.466)",
    xlinkHref: "#x0pfwhiqra"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDisabled);
export default __webpack_public_path__ + "static/media/icon-arrow-disabled.0fd2f8ef9d7ea8fd9054922734785353.svg";
export { ForwardRef as ReactComponent };